import { NgModule } from '@angular/core';
import { CommonModule } from 'app/common.module';
import { ButtonComponent_DEPRECATED } from 'shared/components/button/button-deprecated/button.component';
import { ButtonComponent } from 'shared/components/button/button.component';
import { LoadingSpinnerModule } from 'shared/components/loading-spinner/loading-spinner.module';
import { PopoverModule } from 'shared/components/popover/popover.module';

const ANGULAR_MODULES = [CommonModule];
const SHARED_MODULES = [LoadingSpinnerModule, PopoverModule];

@NgModule({
  imports: [...ANGULAR_MODULES, ...SHARED_MODULES],
  exports: [ButtonComponent, ButtonComponent_DEPRECATED],
  declarations: [ButtonComponent, ButtonComponent_DEPRECATED],
  providers: [],
})
export class ButtonModule {}
